/* eslint-disable */
import React, { FC, useEffect, useRef, useState } from 'react'
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom'
import { toast, ToastOptions } from 'react-toastify'

import {
  ResumoDeDocumentosDeSaidaMapper,
  ResumoDeDocumentosAnalisados,
  UploadDeDocumentos,
  UploadDocumentos,
  useRelacaoDeDocumentos,
  selecaoDeDocumentosParaEnvio
} from 'src/compartilhados'
import {
  Breadcrumb,
  Carregando,
  ErroContainerLayout,
  ErroLayoutContainer,
  Modal,
  ModalRef
} from 'src/componentes'
import { Botao } from 'src/componentes/botao'
import { Api } from 'src/servicos'
import { getApiError } from 'src/servicos/instancias-api'
import { SituacaoUpload } from 'src/tipos'

import {
  ModalMotivoRejeicao,
  ModalVisualizacaoDocumento,
  ModalVisualizacaoDocumentoRef
} from '../../ipgs/alunos/documentos/componentes'
import { ModalMotivoRejeicaoDados } from '../../ipgs/alunos/documentos/componentes/modal-motivo-rejeicao/modal-motivo-rejeicao.component'
import {
  BotaoDeSalvar,
  ContainerBreadcrumbs,
  ContainerDaPagina,
  ContainerDosBotoes,
  DescricaoContainer,
  Dicas,
  TituloComplementar
} from '../../ipgs/alunos/documentos/style'
import { RejeicaoDocumento } from '../../ipgs/alunos/documentos/tipos'
import {
  MapearDocumentosParceiroCertificacao,
  MapearDocumentosTurmaCertificacao
} from './mappers'
import {
  DICA_CONSULTA_DOCUMENTOS_FILA,
  useSomenteConsultaDocumentosFilaTrabalho
} from './somente-consulta-fila-trabalho'

const tituloDaPagina = 'Documentação Parceiro'
const erroAoCarregarDados = 'Ops! Houve algum problema no carregamento dos dados.'
const erroAoBaixarDocumentos = 'Erro ao baixar documentos.'
const erroAoObterDocumentos = 'Não foi possível obter os documentos do parceiro.'
const erroAoAtualizarDocumentos = 'Erro ao atualizar documentos.'
const erroAoEnviarDocumentos = 'Erro ao enviar documentos.'
const erroAoProcessarDocumentos = 'Erro ao processar documentos.'
const erroAoEnviarMotivoAlteracaoAprovado = 'Erro ao enviar motivo alteração'
const ErroAoEnviarAnalises = 'Erro ao enviar análise de aprovação de documentos.'
const toastOptions = { type: 'error' } as ToastOptions

type TipoDocumentoParceiro = 'turma' | 'parceiro'

interface DadosContextoDocumentos {
  entidadeId: string
  nomeUsuario: string
  emailUsuario: string
  nomeTurma: string
}

export type DocumentosParceiroCertificacaoProps = RouteComponentProps<{
  tipo: TipoDocumentoParceiro
  id: string
}>

const DocumentosParceiroCertificacao: FC<DocumentosParceiroCertificacaoProps> = ({
  match
}) => {
  const history = useHistory()
  const somenteConsulta = useSomenteConsultaDocumentosFilaTrabalho()
  const { documentos, atualizar, reiniciar } = useRelacaoDeDocumentos()
  const [pronto, definirPronto] = useState<boolean>()
  const [carregando, definirCarregando] = useState<boolean>()
  const [dadosContexto, definirDadosContexto] = useState<DadosContextoDocumentos>()
  const [rejeicaoDeDocumento, definirRejeicaoDeDocumento] = useState<RejeicaoDocumento>()

  const modalDeCancelamentoRef = useRef<ModalRef>(null)
  const modalMotivoRejeicaoRef = useRef<ModalRef>(null)
  const modalVisualizacaoRef = useRef<ModalVisualizacaoDocumentoRef>(null)

  const { limparErro, definirErro, erro } = ErroLayoutContainer.useContainer()

  const tipoDocumento = match.params.tipo
  const entidadeId = match.params.id
  const isTurma = tipoDocumento === 'turma'

  const montarUrlDeVisualizacao = (base64: string, contentType: string): string => {
    const base64Normalizado = base64?.trim()

    if (!base64Normalizado) return null
    if (base64Normalizado.startsWith('data:')) return base64Normalizado

    const tipoDoConteudo = contentType || 'application/pdf'
    return `data:${tipoDoConteudo};base64,${base64Normalizado}`
  }

  const obterDadosDoParceiro = async (
    parceiroId: string
  ): Promise<{ nome: string; email: string } | null> => {
    try {
      const parceiro = await Api.ObterParceiroCertificacaoPorIdUsuario(parceiroId)

      if (!parceiro) return null

      return {
        nome: parceiro.nome,
        email: parceiro.email
      }
    } catch {
      return null
    }
  }

  const obterContextoTurma = async (
    turmaId: string
  ): Promise<DadosContextoDocumentos | null> => {
    const turma = await Api.RequisitarTurmaCertificacao(turmaId)

    if (!turma) return null

    const parceiro = await obterDadosDoParceiro(turma.usuarioPerfilId)

    return {
      entidadeId: turmaId,
      nomeUsuario: parceiro?.nome ?? 'N/A',
      emailUsuario: parceiro?.email ?? 'N/A',
      nomeTurma: turma.nome
    }
  }

  const obterContextoParceiro = async (
    parceiroId: string
  ): Promise<DadosContextoDocumentos | null> => {
    const parceiro = await obterDadosDoParceiro(parceiroId)

    if (!parceiro) return null

    return {
      entidadeId: parceiroId,
      nomeUsuario: parceiro.nome,
      emailUsuario: parceiro.email,
      nomeTurma: 'N/A'
    }
  }

  const obterResumoDeDocumentos = async (id: string): Promise<void> => {
    try {
      if (isTurma) {
        const resumoDocumentos = await Api.ObterResumoDeDocumentosTurmaCertificacao(id)

        if (resumoDocumentos?.length > 0) {
          reiniciar(MapearDocumentosTurmaCertificacao(resumoDocumentos))
        }

        return
      }

      const resumoDocumentos = await Api.ObterResumoDeDocumentosParceiroCertificacao(id)

      if (resumoDocumentos?.length > 0) {
        reiniciar(MapearDocumentosParceiroCertificacao(resumoDocumentos))
      }
    } catch {
      definirErro({ mensagens: erroAoCarregarDados })
    }
  }

  const uploadDeCriacao = async (
    documentosParaEnvio: UploadDocumentos[]
  ): Promise<boolean> => {
    if (!documentosParaEnvio.length) return true

    const formulario = ResumoDeDocumentosDeSaidaMapper(documentosParaEnvio)
    const resposta = isTurma
      ? await Api.EnviarDocumentosTurmaCertificacao(dadosContexto.entidadeId, formulario)
      : await Api.EnviarDocumentosParceiroCertificacao(
          dadosContexto.entidadeId,
          formulario
        )

    if (!resposta) {
      toast(erroAoEnviarDocumentos, toastOptions)
      return false
    }

    return true
  }

  const uploadDeEdicao = async (
    documentosParaEnvio: UploadDocumentos[]
  ): Promise<boolean> => {
    if (!documentosParaEnvio.length) return true

    const formulario = ResumoDeDocumentosDeSaidaMapper(documentosParaEnvio)
    const resposta = isTurma
      ? await Api.EditarDocumentosTurmaCertificacao(
          dadosContexto.entidadeId,
          formulario
        )
      : await Api.EditarDocumentosParceiroCertificacao(
          dadosContexto.entidadeId,
          formulario
        )

    if (!resposta) {
      toast(erroAoAtualizarDocumentos, toastOptions)
      return false
    }

    const documentosAprovados = documentosParaEnvio.filter(
      x => x.motivoAlteracaoAprovado
    )

    if (documentosAprovados.length > 0) {
      try {
        await Api.AlteracaoAprovado(dadosContexto.entidadeId, documentosAprovados)
      } catch {
        toast(erroAoEnviarMotivoAlteracaoAprovado, toastOptions)
      }
    }

    return true
  }

  const uploadDeAnalises = async (
    analises: UploadDocumentos[]
  ): Promise<boolean> => {
    if (!analises.length) return true

    const resultado = ResumoDeDocumentosAnalisados(analises)

    if (!resultado?.documentos?.length) return true

    const resposta = isTurma
      ? await Api.ValidarDocumentosTurma(resultado)
      : await Api.ValidarDocumentosParceiro(resultado)

    if (!resposta) {
      toast(ErroAoEnviarAnalises, toastOptions)
      return false
    }

    return true
  }

  const uploadDeDocumentos = async (
    edicoes: UploadDocumentos[],
    criacoes: UploadDocumentos[],
    analises: UploadDocumentos[]
  ): Promise<void> => {
    try {
      definirCarregando(true)

      if (edicoes.length > 0) {
        const sucesso = await uploadDeEdicao(edicoes)
        if (!sucesso) return
      }

      if (criacoes.length > 0) {
        const sucesso = await uploadDeCriacao(criacoes)
        if (!sucesso) return
      }

      if (analises.length > 0 && !somenteConsulta) {
        const sucesso = await uploadDeAnalises(analises)
        if (!sucesso) return
      }

      toast('Documentos salvos com sucesso!', { type: 'success' })
      history.goBack()
    } catch (erro) {
      if ((erro as any)?.isAxiosError) {
        return
      }

      const mensagens = await getApiError(erro as Error)
      toast(mensagens[0] || erroAoProcessarDocumentos, toastOptions)
    } finally {
      definirCarregando(false)
    }
  }

  const eventoDeUpload = async (): Promise<void> => {
    const {
      edicoes,
      criacoes,
      analises,
      contador
    } = selecaoDeDocumentosParaEnvio(documentos)

    const contadorSalvavel = somenteConsulta
      ? edicoes.length + criacoes.length
      : contador

    if (contadorSalvavel === 0) {
      toast('Nenhuma alteração pendente para salvar', { type: 'warning' })
      return
    }

    await uploadDeDocumentos(edicoes, criacoes, analises)
  }

  const obterDownloadDeDocumentos = async (documentoId: string): Promise<void> => {
    try {
      if (isTurma) {
        await Api.DownloadDocumentosTurmaCertificacao(
          dadosContexto.entidadeId,
          documentoId
        )
      } else {
        await Api.DownloadDocumentosParceiroCertificacao(
          dadosContexto.entidadeId,
          documentoId
        )
      }
    } catch {
      toast(erroAoBaixarDocumentos, toastOptions)
    }
  }

  const visualizarDocumento = async (documentoId: string) => {
    try {
      const documento = isTurma
        ? await Api.RequisitarDocumentoTurmaCertificacao(
            dadosContexto.entidadeId,
            documentoId
          )
        : await Api.RequisitarDocumentoParceiroCertificacao(
            dadosContexto.entidadeId,
            documentoId
          )

      if (documento) {
        const urlDoDocumento = montarUrlDeVisualizacao(
          documento.base64,
          documento.contentType
        )

        if (!urlDoDocumento) {
          toast(erroAoObterDocumentos, toastOptions)
          return
        }

        modalVisualizacaoRef?.current?.abrir(urlDoDocumento)
      }
    } catch {
      toast(erroAoObterDocumentos, toastOptions)
    }
  }

  const obterDocumentacao = async (): Promise<void> => {
    try {
      definirPronto(false)
      limparErro()

      const contexto = isTurma
        ? await obterContextoTurma(entidadeId)
        : await obterContextoParceiro(entidadeId)

      if (contexto) {
        definirDadosContexto(contexto)
        await obterResumoDeDocumentos(contexto.entidadeId)
      } else {
        definirErro({ mensagens: erroAoCarregarDados })
      }

      definirPronto(true)
    } catch {
      definirErro({ mensagens: erroAoCarregarDados })
    }
  }

  const aprovacao = (id: string): void => {
    const index = documentos.findIndex(x => x.id === id)

    if (index >= 0) {
      const documentoAtualizado = { ...documentos[index] }
      documentoAtualizado.analisado = true
      documentoAtualizado.status = SituacaoUpload.Aprovado
      atualizar(documentoAtualizado)
    }
  }

  const rejeicao = (id: string): void => {
    definirRejeicaoDeDocumento({ id: id })
    modalMotivoRejeicaoRef?.current?.abrir()
  }

  const obterMotivoDaRejeicao = (dados: ModalMotivoRejeicaoDados) => {
    const index = documentos.findIndex(
      x => x.id === rejeicaoDeDocumento.id
    )

    if (index >= 0) {
      const documentoAtualizado = { ...documentos[index] }
      documentoAtualizado.analisado = true
      documentoAtualizado.status = SituacaoUpload.Recusado
      documentoAtualizado.motivoDaRejeicao = dados.motivoDaRejeicao
      atualizar(documentoAtualizado)
    }

    modalMotivoRejeicaoRef?.current?.fechar()
    definirRejeicaoDeDocumento(null)
  }

  const fecharModalDeCancelamento = () => {
    modalDeCancelamentoRef?.current?.fechar()
  }

  const abrirModalDeCancelamento = () => {
    modalDeCancelamentoRef?.current?.abrir()
  }

  useEffect(() => {
    obterDocumentacao()
  }, [match.params.tipo, match.params.id])

  const documentosOrdenados = documentos.sort((a, b) => a.ordemExibicao - b.ordemExibicao)

  if (erro) return <ErroContainerLayout />
  if (!pronto) return <Carregando />

  return (
    <ContainerDaPagina>
      {carregando && <Carregando />}

      <ContainerBreadcrumbs>
        <Breadcrumb atalhos={[]} titulo={tituloDaPagina} />
      </ContainerBreadcrumbs>

      <TituloComplementar>{tituloDaPagina}</TituloComplementar>

      <DescricaoContainer>
        <p>Nome usuário: {dadosContexto?.nomeUsuario}</p>
        <p>E-mail usuário: {dadosContexto?.emailUsuario}</p>
        <p>Nome da turma: {dadosContexto?.nomeTurma}</p>
      </DescricaoContainer>

      <Dicas>
        {somenteConsulta
          ? DICA_CONSULTA_DOCUMENTOS_FILA
          : 'Analise cada documento e aprove ou recuse conforme a conformidade.'}
      </Dicas>

      {documentosOrdenados.map((documento) => (
        <UploadDeDocumentos
          key={documento.id}
          documento={documento}
          eventoDeVisualizacao={visualizarDocumento}
          eventoDeDownload={obterDownloadDeDocumentos}
          eventoDeMudanca={atualizar}
          controleDeAprovacao={{
            ativo: !somenteConsulta,
            eventoDeAprovacao: aprovacao,
            eventoDeRejeicao: rejeicao
          }}
          modoVisualizacao={true}
          somenteConsulta={somenteConsulta}
        />
      ))}

      <ContainerDosBotoes>
        <Botao
          texto={somenteConsulta ? 'Voltar' : 'Cancelar'}
          onClick={somenteConsulta ? () => history.goBack() : abrirModalDeCancelamento}
        />
        {!somenteConsulta && (
          <BotaoDeSalvar texto="Salvar" onClick={eventoDeUpload} />
        )}
      </ContainerDosBotoes>

      <Modal
        ref={modalDeCancelamentoRef}
        titulo="Deseja cancelar?"
        acaoPrimaria={{
          titulo: 'Sim',
          acao: () => history.goBack()
        }}
        acaoSecundario={{
          titulo: 'Não',
          acao: fecharModalDeCancelamento
        }}
      >
        Tem certeza que deseja sair sem salvar as alterações?
      </Modal>

      <ModalMotivoRejeicao
        ref={modalMotivoRejeicaoRef}
        acaoPrimaria={obterMotivoDaRejeicao}
      />

      <ModalVisualizacaoDocumento
        ref={modalVisualizacaoRef}
        id="modal-visualizacao-documento-parceiro-certificacao"
      />
    </ContainerDaPagina>
  )
}

const Container: FC<DocumentosParceiroCertificacaoProps> = (
  props: DocumentosParceiroCertificacaoProps
) => (
  <ErroLayoutContainer.Provider>
    <DocumentosParceiroCertificacao {...props} />
  </ErroLayoutContainer.Provider>
)

export default withRouter(Container)
